"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseError = exports.splitArrayIntoChunks = exports.generateShortUID = exports.sleepMs = void 0;
const common_logging_1 = require("@sundaysky/common-logging");
const sleepMs = (timeMs) => new Promise(res => setTimeout(res, timeMs));
exports.sleepMs = sleepMs;
const logger = (0, common_logging_1.generateLogger)("generalUtils");
/**
 * Generates a short UUID (6 chars long)
 * @return 6 chars long UUID
 */
const generateShortUID = () => {
    // Generate the UID from two parts here
    // to ensure the random number provides enough bits.
    const firstPart = (Math.random() * 46656) | 0;
    const secondPart = (Math.random() * 46656) | 0;
    const firstPartStr = ("000" + firstPart.toString(36)).slice(-3);
    const secondPartStr = ("000" + secondPart.toString(36)).slice(-3);
    return firstPartStr + secondPartStr;
};
exports.generateShortUID = generateShortUID;
/**
 * splits an array to smaller arrays of the side of itemsPerChunk
 * @param array - array to split
 * @param itemsPerChunk - max items in each chuck
 * @returns an array of arrays that hold itemsPerChunk items (last check might be smaller than itemsPerChunk)
 */
function splitArrayIntoChunks(array, itemsPerChunk) {
    logger.info(`Starting to split an array of size ${array.length} to chunks of ${itemsPerChunk}`);
    let chunks = [];
    let i = 0;
    let arrayLength = array.length;
    while (i < arrayLength) {
        chunks.push(array.slice(i, i += itemsPerChunk));
    }
    logger.info(`Split successfully to ${chunks.length} chunks.`);
    return chunks;
}
exports.splitArrayIntoChunks = splitArrayIntoChunks;
class BaseError extends Error {
    constructor(message, innerError) {
        super(message);
        this.innerError = innerError;
    }
}
exports.BaseError = BaseError;
//# sourceMappingURL=generalUtils.js.map